export const Metric = 'Metric';
export const UpperLimit = 'Upper Limit';
export const LowerLimit = 'Lower Limit';
export const Actual = 'Actual';
export const Notes = 'Notes';
export const Status = 'Status';
